import { Button, ConfirmationPopup, Loader, SuccessModal } from '@ohif/ui'
// import { CustomizedModal } from 'platform/ui/src/components'
import CustomizedModal from '../../../../ui/src/components/CustomizedModal/CustomizedModal'
import React, { useEffect, useState } from 'react'
import RejectionReason from './enums'
import { _studyDataUrls } from '@custom/Utils/constants/apiUrls'
import { servicesManager } from '../../App'
import { mergePropType } from '@custom/Utils/constants/interfaces'
import { getCloudPACSToken } from '@custom/Utils/authUtils'

const MergeStudies = (props:mergePropType) => {

  const { studiesToSend,setMergeModal,mergeModal} = props
  const [isPopupOpen,setisPopupOpen] = useState(false)
  const [isSuccessModalOpen,setIsSuccessModalOpen] = useState(false)
  const [title,setTitle] = useState('')
  const [loading,setLoading] = useState(false)
  const [mergeStudiesPayload, setMergeStudiesPayload] = useState({
    targetStudy:'',
    selectedStudy:studiesToSend,
    rejectionReasonId : ''
  })

  const {uiNotificationService } = servicesManager.services

  const closeModal = () =>{
    setMergeModal(false)
    setMergeStudiesPayload({
      targetStudy:'',
      selectedStudy:[],
      rejectionReasonId : ''
    })
  }

  const camelCaseToTitleCase =(str)=> {
    return str
      // Insert a space before each uppercase letter
      .replace(/([A-Z])/g, ' $1')
      // Capitalize the first letter
      .replace(/^./, function(char) { return char.toUpperCase(); });
  }


  const RenderModalContent = () => {

    const [errors, setErrors] = useState({
      targetStudy:'',
      rejectionReasonId : ''
    });


    const validateForm = () => {
      const newErrors = {
        targetStudy:'',
        rejectionReasonId : ''
      };

      if (!mergeStudiesPayload.rejectionReasonId) {
        newErrors.rejectionReasonId = 'Merge reason is required';
      }

      if (!mergeStudiesPayload.targetStudy) {
        newErrors.targetStudy = 'Target study is required';
      }

      setErrors(newErrors);

      return !newErrors.rejectionReasonId && !newErrors.targetStudy;
    };

    const handleMerge =()=>{
      if(validateForm()){
        setMergeStudiesPayload({...mergeStudiesPayload, ['selectedStudy']: studiesToSend})
        setisPopupOpen(true)
      }
    }

    const handleChange = (e:any)=>{
      setMergeStudiesPayload({
        ...mergeStudiesPayload, [e.target.name] : e.target.value
      })

      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }

    const handleConfirm = async() =>{
      const studiesToMerge = mergeStudiesPayload.selectedStudy.filter((x)=> x.studyInstanceUid != mergeStudiesPayload.targetStudy)
      setLoading(true)
      let count = 0
      if(studiesToMerge.length > 0){
        studiesToMerge.map(async(study)=>{

      try {
        let url = `${_studyDataUrls.mergeStudy(mergeStudiesPayload.targetStudy,mergeStudiesPayload.rejectionReasonId)}`
        const pacs_token = getCloudPACSToken();
        let response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${pacs_token}`,
          },
          body : JSON.stringify({
            'StudyInstanceUID' : study.studyInstanceUid
          })
        })
        if(response.status >= 200 && response.status <=300){
          const responseBody = await response.json()
          ++count
          if(count == studiesToMerge.length){
            setTitle('Studies merged Successfully.')
            setIsSuccessModalOpen(true)
            setLoading(false)
            setMergeModal(false)
            const url = window.location.origin
            setTimeout(() => {
              window.location.href = url
            }, 2000);
          }
        }else if(response.status >= 400){
          const error = await response.json()
          uiNotificationService.show({
            title:'Error',
            message: error?.errorMessage,
            type:'error',
            position:'topRight'
          })
          setisPopupOpen(false)
          setMergeModal(false)
        }
      } catch (error) {
        console.log('error',error);
        return error;
      } finally{
        setLoading(false)
      }
        })
      }
    }

    const handleCancel = () => {
      setisPopupOpen(false)
    }

    const headers = studiesToSend.length > 0
    ? Object.keys(studiesToSend[0]).filter(key =>key !== 'accession' && key !== 'date' && key !== 'time' && key !== 'mrn' && key !== 'instances' && key !== 'description')
    : [];

    return <div key="ui" className='flex items-start justify-center flex-col gap-2'>
    <div className='text-black mb-4'>Merge Reason</div>
    <div className='mb-2 flex flex-col items-start justify-center w-full'>
      <select
        id="rejectionReasonId"
        name="rejectionReasonId"
        className="custom-select text-[#666666]"
        onChange={handleChange}
        value={mergeStudiesPayload.rejectionReasonId}
      >
        <option value="">-Select-</option>
        {RejectionReason.map((option) => (
          <option className='text-black' key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors.rejectionReasonId && <span className="text-red-500">{errors.rejectionReasonId}</span>}
    </div>
    <div className='w-full'>
  <div className='mb-1'>Please select Target Study</div>
  <div className="w-full overflow-x-auto">
    <table className="min-w-full border border-gray-300">
      <thead>
        <tr className="bg-[#0F8491] text-white">
          <th className="px-4 py-2 border border-gray-300">Select</th>
          {headers.map((header, index) => (
            <th key={index} className="px-4 py-2 border border-gray-300 capitalize">
              {camelCaseToTitleCase(header)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {studiesToSend.map((study, index) => (
          <tr key={index} className="hover:bg-gray-100">
            <td className="px-4 py-2 border border-gray-300">
              <input
                type="radio"
                name="targetStudy"
                value={study.studyInstanceUid}
                checked={study.studyInstanceUid == mergeStudiesPayload.targetStudy}
                onChange={handleChange}
                className="form-radio text-indigo-600"
              />
            </td>
            {headers.map((header, idx) => (
              <td key={idx} className="px-4 py-2 border border-gray-300 whitespace-nowrap overflow-hidden text-ellipsis">
                {study[header]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
      {errors.targetStudy && <span className="text-red-500">{errors.targetStudy}</span>}
  </div>
</div>


    <div className='py-1 mt-1 flex space-x-4'>
      <button className='btn btn__white' name='Cancel' onClick={closeModal}>
        Cancel
      </button>
      <Button className='btn btn__primary'  name='Download' onClick={handleMerge}>
        Merge
      </Button>
    </div>
    <ConfirmationPopup
        isOpen={isPopupOpen}
        title="Merging Studies"
        message={`Are you sure you want merge these studies ?`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
  </div>
  }

  return <div>

      <Loader isLoaderOpen={loading} />
      <CustomizedModal
      closeButton={true}
      shouldCloseOnEsc={true}
      isOpen={mergeModal}
      title={'Merging Studies'}
      onClose={closeModal}
      shouldCloseOnOverlayClick={true}
      containerDimensions='84vw, auto'
      children={
      <RenderModalContent />
    }
    ></CustomizedModal>
    <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={title}
        handleCloseModal={() => setIsSuccessModalOpen(false)}
      />
    </div>

}

export default MergeStudies
